export default {"src":"/_next/static/image/public/landing/wave_pattern.5560a928fb9ec1bc51f9a73d2a39c85a.svg","height":123,"width":194};